export default __webpack_public_path__ + "static/media/oregon.6ac08aa7.jpg";